module.exports = __webpack_public_path__ + "static/media/AnandSoni@3x.241cbcaa.png";